import React, { ReactNode, useEffect, useState } from 'react';
import { KeycloakUserInfo } from './types/KeycloakUserInfo';

interface AuthProviderProps {
    children: ReactNode;
    userInfo: KeycloakUserInfo;
}

interface IAuthContext {
    userInfo: KeycloakUserInfo;
    setLocumUserName: React.Dispatch<React.SetStateAction<string>>;
    locumUserName: string;
}

export const AuthContext = React.createContext<Partial<IAuthContext>>({});

export default function AuthProvider({ children, userInfo }: AuthProviderProps) {
    const [locumUserName, setLocumUserName] = useState<string>(localStorage.getItem('locumUserName') || '');

    useEffect(() => {
        if (locumUserName !== '') {
            localStorage.setItem('locumUserName', locumUserName);
        }
    }, [locumUserName]);

    const contextValue = {
        userInfo: userInfo,
        setLocumUserName: setLocumUserName,
        locumUserName: locumUserName
    };

    return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
}
